'use client';

import { FormHelperText, Typography } from '@mui/material';

import { InfoOutlined } from '../../icons';
import { styled } from '../../styles';

import { StyledFormHelperTextProps } from './types';

const FormHelperTextStyled = styled(FormHelperText)<StyledFormHelperTextProps>(
  ({ theme }) => ({
    '.MuiTypography-root': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
  }),
);

export const FormHelperTextLabel = styled(
  FormHelperTextStyled,
)<StyledFormHelperTextProps>(({ theme }) => ({
  color: theme.palette.text3,
  marginBottom: theme.spacing(2),
}));

export const FormHelperTextHelperText = styled(
  FormHelperTextStyled,
)<StyledFormHelperTextProps>(({ theme, error }) => ({
  color: error ? theme.palette.error.main : theme.palette.text3,
  marginTop: 2,
}));

export const FormHelperTextHelperTooltipIcon = styled(
  InfoOutlined,
)<StyledFormHelperTextProps>(
  () =>
    ({
      width: 12,
      height: 12,
      position: 'relative',
      cursor: 'pointer',
    } as const),
);

export const LabelStyled = styled(Typography)(
  () =>
    ({
      float: 'left',
    } as const),
);
